<template>
  <div class="contactus-new">
    <div class="contactbanner">
      <div class="title">AI 平台-机器学习的算力优化和开发运维</div>
      <div class="contact-area">
        <div class="section" :style="{backgroundImage: 'url(' + src2 + ')'}">
          <img src="../assets/images/phone-contact-new.png" style="margin-right: 20px"/>
          业务咨询：13033677897
        </div>
        <div class="section" :style="{backgroundImage: 'url(' + src1 + ')'}">
          <img src="../assets/images/email-contact-new.png" style="margin-right: 20px"/>
          邮箱：sales@anchora.me
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'ContactUsNew',
    data() {
      return {
        src1: require('../assets/images/section1-contact-new.png'),
        src2: require('../assets/images/section2-contact-new.png')
      }
    }
  }
</script>

<style>
  @media(min-width: 992px) {
    .contactbanner {
      width: 100%;
      height: 38.49vw;
      background-repeat: no-repeat;
      background-size: 100% 100%;
      background-image: url("../assets/images/banner-contact-new.png");
      overflow-y: hidden;
      margin-top: 72px;
    }
    .contactbanner .title {
      font-size: 50px;
      font-weight: 500;
      color: #FFFFFF;
      line-height: 63px;
      margin-top: 9.8vw;
      margin-left: 16.93vw;
      text-align: left;
    }
    .contactbanner .contact-area {
      margin: 11.35vw 16.93vw 0;
      display: flex;
      align-items: center;
      justify-content: space-between;
    }
    .contactbanner .contact-area .section {
      width: 29.375vw;
      height: 7.24vw;
      background-repeat: no-repeat;
      background-size: 100% 100%;
      font-size: 26px;
      font-weight: 400;
      color: #FFFFFF;
      line-height: 38px;
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }
  @media(max-width:992px) {
    .banner {
      height: 198px;
      background-repeat: no-repeat;
      background-size: 100% 100%;
    }

    .banner .banner-overlay1 {
      padding: 70px 30px 0;
      color: #FFFFFF;
      text-align: left;
    }

    .banner .banner-overlay1 h1 {
      color: #FFFFFF;
      font-size: 18px;
      transform: translateY(0px);
      line-height: 24px;
      transition: all 0.6s;
      margin-bottom: 5px;
    }

    .banner .banner-overlay1 p {
      color: rgba(255, 255, 255, .5);
      font-size: 14px;
      transform: translateY(0px);
      line-height: 14px;
      transition: all 0.6s;
    }

    .banner .banner-overlay1 .try-btn-area {
      color: #FFFFFF;
      width: initial;
      text-align: left;
      font-size: 48px;
      line-height: 48px;
      margin-top: 10px;
    }

    .banner .banner-overlay1 .try-btn-area .el-button {
      type: small;
      margin-left: 0;
    }
  }
</style>
<style></style>


// WEBPACK FOOTER //
// src/components/ContactUsNew.vue